var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.resultRow.actions, function (action, index) {
    return _c('div', [index !== 0 ? _c('p', [_c('i', [_vm._v("en")])]) : _vm._e(), _c('p', [_c('trigger-text-field-with-edit', {
      attrs: {
        "api": `/api/trigger-actions/${action.id}`,
        "field": "description"
      },
      model: {
        value: action.description,
        callback: function ($$v) {
          _vm.$set(action, "description", $$v);
        },
        expression: "action.description"
      }
    }, [_vm._v(" " + _vm._s(_vm.nl2br(action.description)) + " "), _c('b-button', {
      staticClass: "p-0 m-0 ml-1 d-inline-block",
      attrs: {
        "variant": "light",
        "size": "sm"
      },
      on: {
        "click": function ($event) {
          return _vm.$bvModal.show(`trigger_action_${action.id}`);
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "text-secondary",
      attrs: {
        "icon": "circle-question"
      }
    })], 1)], 1)], 1), _c('b-modal', {
      attrs: {
        "id": `trigger_action_${action.id}`
      }
    }, [_c('pre', [_vm._v(_vm._s(action.parameters))])])], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }